module.exports = __webpack_public_path__ + "static/img/sec1-slide-img03.376e161.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hanssem/sec1-slide-img03.jpg
// module id = Wb+3
// module chunks = 0